module.exports = __webpack_public_path__ + "img/banner-bckg-light.b0ff3600.png";